/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateTopic = /* GraphQL */ `
  subscription OnCreateTopic($domainId: String!) {
    onCreateTopic(domainId: $domainId) {
      id
      domainId
      title
      desc
      icon {
        url
        mime
      }
      pinned
      categoryId
      messages
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
      notification
    }
  }
`;
export const onUpdateTopic = /* GraphQL */ `
  subscription OnUpdateTopic($domainId: String!) {
    onUpdateTopic(domainId: $domainId) {
      id
      domainId
      title
      desc
      icon {
        url
        mime
      }
      pinned
      categoryId
      messages
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
      notification
    }
  }
`;
export const onDeleteTopic = /* GraphQL */ `
  subscription OnDeleteTopic($domainId: String!) {
    onDeleteTopic(domainId: $domainId) {
      id
      domainId
      title
      desc
      icon {
        url
        mime
      }
      pinned
      categoryId
      messages
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
      notification
    }
  }
`;
export const onCreateMessage = /* GraphQL */ `
  subscription OnCreateMessage($domainId: String!, $topicId: String!) {
    onCreateMessage(domainId: $domainId, topicId: $topicId) {
      id
      domainId
      topicId
      title
      message
      pinned
      owner
      commentId
      photos {
        url
        mime
      }
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
    }
  }
`;
export const onUpdateMessage = /* GraphQL */ `
  subscription OnUpdateMessage($domainId: String!, $topicId: String!) {
    onUpdateMessage(domainId: $domainId, topicId: $topicId) {
      id
      domainId
      topicId
      title
      message
      pinned
      owner
      commentId
      photos {
        url
        mime
      }
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
    }
  }
`;
export const onDeleteMessage = /* GraphQL */ `
  subscription OnDeleteMessage($domainId: String!, $topicId: String!) {
    onDeleteMessage(domainId: $domainId, topicId: $topicId) {
      id
      domainId
      topicId
      title
      message
      pinned
      owner
      commentId
      photos {
        url
        mime
      }
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
    }
  }
`;
export const onCreateComment = /* GraphQL */ `
  subscription OnCreateComment(
    $domainId: String!
    $topicId: String!
    $messageId: String!
  ) {
    onCreateComment(
      domainId: $domainId
      topicId: $topicId
      messageId: $messageId
    ) {
      id
      domainId
      topicId
      messageId
      message
      photos {
        url
        mime
      }
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
    }
  }
`;
export const onUpdateComment = /* GraphQL */ `
  subscription OnUpdateComment(
    $domainId: String!
    $topicId: String!
    $messageId: String!
  ) {
    onUpdateComment(
      domainId: $domainId
      topicId: $topicId
      messageId: $messageId
    ) {
      id
      domainId
      topicId
      messageId
      message
      photos {
        url
        mime
      }
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
    }
  }
`;
export const onDeleteComment = /* GraphQL */ `
  subscription OnDeleteComment(
    $domainId: String!
    $topicId: String!
    $messageId: String!
  ) {
    onDeleteComment(
      domainId: $domainId
      topicId: $topicId
      messageId: $messageId
    ) {
      id
      domainId
      topicId
      messageId
      message
      photos {
        url
        mime
      }
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
      acl {
        id
        refId
        refIdType
        base {
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        guest {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
        items {
          id
          refId
          refIdType
          create
          read
          update
          delete
          createTopic
          createMessage
          createComment
          createReactions
        }
      }
    }
  }
`;
export const onCreateIconReaction = /* GraphQL */ `
  subscription OnCreateIconReaction($domainId: String!) {
    onCreateIconReaction(domainId: $domainId) {
      type
      targetType
      domainId
      topicId
      messageId
      commentId
      userIdList
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateIconReaction = /* GraphQL */ `
  subscription OnUpdateIconReaction($domainId: String!) {
    onUpdateIconReaction(domainId: $domainId) {
      type
      targetType
      domainId
      topicId
      messageId
      commentId
      userIdList
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteIconReaction = /* GraphQL */ `
  subscription OnDeleteIconReaction($domainId: String!) {
    onDeleteIconReaction(domainId: $domainId) {
      type
      targetType
      domainId
      topicId
      messageId
      commentId
      userIdList
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCategory = /* GraphQL */ `
  subscription OnCreateCategory($domainId: String!) {
    onCreateCategory(domainId: $domainId) {
      id
      title
      domainId
      color
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
    }
  }
`;
export const onUpdateCategory = /* GraphQL */ `
  subscription OnUpdateCategory($domainId: String!) {
    onUpdateCategory(domainId: $domainId) {
      id
      title
      domainId
      color
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
    }
  }
`;
export const onDeleteCategory = /* GraphQL */ `
  subscription OnDeleteCategory($domainId: String!) {
    onDeleteCategory(domainId: $domainId) {
      id
      title
      domainId
      color
      owner
      updatedAt
      createdAt
      deleted
      deletedUser
    }
  }
`;
export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser($owner: String!) {
    onCreateUser(owner: $owner) {
      id
      directId
      name
      profileIcon
      domainIdList
      owner
      favorites
      likes
      updatedAt
      createdAt
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser($owner: String!) {
    onUpdateUser(owner: $owner) {
      id
      directId
      name
      profileIcon
      domainIdList
      owner
      favorites
      likes
      updatedAt
      createdAt
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser($owner: String!) {
    onDeleteUser(owner: $owner) {
      id
      directId
      name
      profileIcon
      domainIdList
      owner
      favorites
      likes
      updatedAt
      createdAt
    }
  }
`;
export const onCreateDomainUser = /* GraphQL */ `
  subscription OnCreateDomainUser {
    onCreateDomainUser {
      domainId
      userDirectId
      user {
        id
        directId
        name
        profileIcon
        domainIdList
        owner
        favorites
        likes
        updatedAt
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateDomainUser = /* GraphQL */ `
  subscription OnUpdateDomainUser {
    onUpdateDomainUser {
      domainId
      userDirectId
      user {
        id
        directId
        name
        profileIcon
        domainIdList
        owner
        favorites
        likes
        updatedAt
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteDomainUser = /* GraphQL */ `
  subscription OnDeleteDomainUser {
    onDeleteDomainUser {
      domainId
      userDirectId
      user {
        id
        directId
        name
        profileIcon
        domainIdList
        owner
        favorites
        likes
        updatedAt
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateNotifications = /* GraphQL */ `
  subscription OnCreateNotifications {
    onCreateNotifications {
      id
      domainId
      title
      desc
      users
      departments
      exclude_users
      exclude_departments
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateNotifications = /* GraphQL */ `
  subscription OnUpdateNotifications {
    onUpdateNotifications {
      id
      domainId
      title
      desc
      users
      departments
      exclude_users
      exclude_departments
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteNotifications = /* GraphQL */ `
  subscription OnDeleteNotifications {
    onDeleteNotifications {
      id
      domainId
      title
      desc
      users
      departments
      exclude_users
      exclude_departments
      createdAt
      updatedAt
    }
  }
`;
